<template>
  <div class="app-container">
    <!-- <div class="searchBox"> -->
      <el-tabs v-model="activeName"  >
        <el-tab-pane label="应收明细" name="one" style="">
          <tabYS v-if="activeName=='one'"></tabYS>
        </el-tab-pane>
        <el-tab-pane label="账单管理" name="two">
          <!-- <maintainUsers :basic-data="basicData"  v-if="activeName=='two'"></maintainUsers> -->
          <tabZDGL v-if="activeName=='two'"></tabZDGL>
        </el-tab-pane>
      </el-tabs>
    <!-- </div> -->
  </div>
</template>
<script>
import tabYS from '@/views/newTMS/transportation/caiWuManage/yingShouSettlement/tabYS.vue'
import tabZDGL from '@/views/newTMS/transportation/caiWuManage/yingShouSettlement/tabZDGL.vue'
export default {
  components: {
    tabYS,
    tabZDGL
  },
  data () {
    return {
      activeName: 'one',
      h: '500px'
    }
  },
  created () {
    if (this.$route.query.ZDFlag) {
      this.activeName = 'two'
    } else {
      this.activeName = 'one'
    }
  },
  beforeRouteEnter (to, from, next) {
    if (from.path == '/ZDdetils') {
      to.meta.isBack = true
    } else {
      to.meta.isBack = false
    }
    next()
  }
}
</script>
<style scoped lang='less'>
/deep/.el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
  background-color: #0c46a2 !important;
  color: #fff;
}
/deep/.el-tabs__header{
  margin: 0;
}
</style>
